// extracted by css-extract-rspack-plugin
export default {"navButton":"iLtvH","avatarStack":"T7SaK","channelAvatar":"oiRy5","detailsTable":"q_w68"};